module.exports = __webpack_public_path__ + "img/strength.dba865f7.svg";